// removed by extract-text-webpack-plugin
module.exports = {"root":"socialLink__root--Qnwbx","icon":"socialLink__icon--28iiL","hidden":"socialLink__hidden--11Ln3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/SocialLink/socialLink.css
// module id = oMMB
// module chunks = 0